import type { PlayerInjury } from "../../../../common/types.ts";
import i18n from "../util/i18n.ts";
import { translateInjuryName } from "../util/injuryNames.ts";
import { MobileTooltip } from "./MobileTooltip.tsx";

export const InjuryIcon = ({
	className = "",
	injury,
}: {
	className?: string;
	injury?: PlayerInjury & {
		playingThrough?: boolean;
	};
}) => {
	if (injury === undefined) {
		return null;
	}

	const colorClass = injury.playingThrough ? "warning" : "danger";

	let info;
	if (injury.gamesRemaining === -1) {
		// This is used in box scores, where it would be confusing to display "out X more days" in old box scores
		info = {
			title: translateInjuryName(injury.type),
			text: "+",
		};
	} else if (injury.gamesRemaining > 0 || injury.type !== "Healthy") {
		let title = i18n.t("injuryIcon.outMore", {
			ns: "ui",
			defaultValue: "{{injury}}, out {{count}} more days",
			injury: translateInjuryName(injury.type),
			count: injury.gamesRemaining,
		});
		if (injury.playingThrough) {
			title = i18n.t("injuryIcon.playedThrough", {
				ns: "ui",
				defaultValue: "{{title}}, played through injury",
				title,
			});
		}

		info = {
			title,
			text: injury.gamesRemaining,
		};
	}

	if (info) {
		return (
			<MobileTooltip title={info.title}>
				<span className={`badge bg-${colorClass} badge-injury ${className}`}>
					{info.text}
				</span>
			</MobileTooltip>
		);
	}

	return null;
};
